import { useQuery } from "@tanstack/react-query";
import instance from "services/axiosServices";
import leadsWebEnviroment from "utils/leadsWebEnviroment";

interface Props {
  queryKey?: string;

  idEquipe?: number;
}
export function useGetFiltrarCampanhas(props: Props) {
  const hasIdEquipe = props.idEquipe ? `idEquipe=${props.idEquipe}` : "";
  const fetchData = async () => {
    const LISTAR_DESTAQUES = `${leadsWebEnviroment}/common/campanha/campanhas-equipe/v1?${hasIdEquipe}`;
    const response = await instance.get(LISTAR_DESTAQUES);
    return response?.data?.data;
  };

  const query = useQuery({
    enabled: !!props.idEquipe || true,
    queryFn: fetchData,
    queryKey: [props.queryKey || "filtrar_campanhas"],
    refetchOnWindowFocus: false,
  });

  return query;
}
